import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import { withAuth } from "@okta/okta-react"

export default withAuth(
  withRouter(
    class Home extends Component {
      state = { authenticated: null }

      checkAuthentication = async () => {
        const authenticated = await this.props.auth.isAuthenticated()
        if (authenticated !== this.state.authenticated) {
          this.setState({ authenticated })
        }
      }

      async componentDidMount() {
        this.checkAuthentication()
      }

      async componentDidUpdate() {
        this.checkAuthentication()
      }

      login = async () => {
        this.props.auth.login("/")
      }

      logout = async () => {
        this.props.auth.logout("/")
      }

      render() {
        if (this.state.authenticated === null) return null

        const mainContent = this.state.authenticated ? (
          <div>
            <p className="lead">
              Welcome to SmartSite! Please <Link to="/secure">click here!</Link>
            </p>
            <button className="btn btn-light btn-lg" onClick={this.logout}>
              Logout
            </button>
          </div>
        ) : (
          <div>
            <p className="lead">
              Welcome to SmartSite! Please contact your administrator if you
              need sign in credentials
            </p>
            <button className="btn btn-dark btn-lg" onClick={this.login}>
              Login
            </button>
          </div>
        )

        if (this.state.authenticated) {
          this.props.history.push("/secure")
        }

        if (!this.state.authenticated) {
          this.props.history.push("/login")
        }

        return (
          <div className="jumbotron">
            <h1 className="display-4">SmartSite</h1>
            {mainContent}
          </div>
        )
      }
    }
  )
)



// WEBPACK FOOTER //
// ./src/components/pages/Home.js